// nuolino-admin/src/components/ui/ToastContext.ts
// Context isolado. Separado de Toast.tsx para fast-refresh limpo.

import { createContext } from 'react';
import type { ToastContextValue } from './toast-types';

export const ToastContext = createContext<ToastContextValue | null>(null);
